import React, { useCallback } from 'react';
import classNames from 'classnames';

import { JourneyMenu, JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import FrameImageLightIcon from 'src/monet/icons/FrameImageLightIcon';
import { CopyToClipboardWithStyles } from 'src/dashboard/JourneyShareThumbnailCode';
import { useNotificationMessage } from 'src/common/notification/message.hook';
import { useShareThumbnailCodeStore } from './thumbnail-code/store';
import { thumbnailElementId } from './thumbnail-code/get-template';
import LoadingSpinner from 'src/common/components/loading-spinner';

interface Props extends Pick<JourneyMenuPropsInterface, 'openRef' | 'closeRef' | 'onClose'> {
  menuButton: JSX.Element;
}

export const ShareCopyLinkMenuOptions = ({ openRef, closeRef, onClose, menuButton }: Props) => {
  const { isThumbnailReady } = useShareThumbnailCodeStore((state) => ({
    isThumbnailReady: !!state.thumbnailElement,
  }));
  const { setSuccessNotification } = useNotificationMessage();

  const renderOrigin = useCallback(() => menuButton, [menuButton]);

  const onCopyLinkMenuItemClicked = () => {
    CopyToClipboardWithStyles(thumbnailElementId);
    setSuccessNotification('Thumbnail link copied to clipboard');
  };

  return (
    <>
      <JourneyMenu
        placement='bottom-start'
        containerClassName='w-60 py-[14px] max-h-[360px] overflow-y-auto'
        openRef={openRef}
        closeRef={closeRef}
        onClose={onClose}
        renderOrigin={renderOrigin}
      >
        {!isThumbnailReady ? (
          <div className='flex items-center justify-center h-[66px]'>
            <LoadingSpinner />
          </div>
        ) : (
          <>
            <JourneyMenu.Item className='text-bedrock-p-small text-left text-bedrock-black pointer-events-none'>
              Use this link within Gmail to show a thumbnail of your Journey
            </JourneyMenu.Item>
            <JourneyMenu.Item
              className={classNames('text-bedrock-p text-bedrock-black flex items-start space-x-sm text-left', {
                'pointer-events-none': !isThumbnailReady,
              })}
              onClick={onCopyLinkMenuItemClicked}
            >
              <div className='flex space-x-2'>
                <FrameImageLightIcon className='shrink-0' />
                <span className='text-bedrock-p'>Copy thumbnail link</span>
              </div>
            </JourneyMenu.Item>
          </>
        )}
      </JourneyMenu>
    </>
  );
};
